module.exports = __webpack_public_path__ + "static/img/map.ecd8eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map.png
// module id = 9i06
// module chunks = 2